import { useContext } from "react"
import { LoginContext, LoginContextValue } from "src/contexts/LoginContext"

export const useLoginContext = () => {
  const context = useContext(LoginContext) as LoginContextValue
  if (!context) {
    throw new Error("Make sure to only call useLoginContext within a  <LoginProvider>")
  }
  return context
}
